import useSWR, {SWRConfiguration} from 'swr';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {Term} from './types';

export function fetchTermsRequest(swrConfig?: SWRConfiguration<Term[]>) {
  return useSWR<Term[]>(
    '/api/v1/terms/',
    (url) => letrusAPI(url).then((res) => res.data),
    {revalidateOnFocus: false, shouldRetryOnError: false, ...swrConfig},
  );
}
